var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('section',{staticClass:"hero"},[_c('Button',{attrs:{"text":"Prototype","type":"is-primary","icon":"!forward"},nativeOn:{"click":function($event){_vm.isOnboardingModalActive = !_vm.isOnboardingModalActive}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }